import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  partnersMembersApi,
  partnersMembersApiKeys,
} from '@/api/routes/partners/partners.members.api';

/** Withdraw an open invite; the API message (e.g. already accepted) goes to the global snackbar. */
export const usePartnersRevokeMemberInvite = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (inviteId: string) => partnersMembersApi.revokeInvite(inviteId),
    // Settled, not success: a 404 means the list on screen is already stale.
    onSettled: () => queryClient.invalidateQueries({ queryKey: partnersMembersApiKeys.all }),
  });
};
